import WorkoutGenInstructions from './WorkoutGenInstructions';

export default WorkoutGenInstructions;
